import { createContext, useContext } from 'react';
import type { SearchBrowseDataContextValue } from './types';

const SearchBrowseDataContext =
  createContext<SearchBrowseDataContextValue | null>(null);

export function useSearchBrowseData(): SearchBrowseDataContextValue | null {
  return useContext(SearchBrowseDataContext);
}

export { SearchBrowseDataContext };
